import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { getTransferDetails } from 'entities/ticket/lib/getTransferDetails'
import { ISegmentFly } from 'entities/ticket/ui/card-of-ticket/module'

import DividerIcon from 'shared/icons/divider_small.svg'
import LineIcon from 'shared/icons/line.svg'
import { prepareTimeShow } from 'shared/lib/ticketRender.ts'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface Props {
  data: ISegmentFly
}

export const FlightInfo = ({ data }: Props) => {
  const { t } = useTranslation()

  const timeFlight = prepareTimeShow(parseInt(`${data.time?.time || 0}`))
  const countTransfer = parseInt(data?.time?.countSegment || '0')

  const transfers = getTransferDetails(
    countTransfer,
    data.is_airport_change,
    data.baggage_recheck,
  )

  const timeFlightText = t('time_flight', {
    hours: timeFlight?.hours,
    minutes: timeFlight?.minutes,
  })

  return (
    <div className={s.container}>
      <ImageLazy
        src={DividerIcon}
        className={s.dividerIcon}
      />
      <div className={s.body}>
        <div className={s.block}>
          <span className={clsx('semi-bold-16', s.time)}>
            {data?.from?.time}
          </span>
          <span className={clsx('medium-14', s.direction)}>
            {data?.from?.name}
          </span>
        </div>

        <div className={s.duration}>
          <span className={clsx('medium-12', s.title)}>{timeFlightText}</span>

          <ImageLazy
            src={LineIcon}
            className={s.line}
          />
          <span className={clsx('medium-12', s.subtitle)}>{transfers}</span>
        </div>

        <div className={s.block}>
          <span className={clsx('semi-bold-16', s.time)}>{data?.to?.time}</span>
          <span className={clsx('medium-14', s.direction)}>
            {data?.to?.name}
          </span>
        </div>
      </div>
    </div>
  )
}
